import React from 'react';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import Icon from './Icon';

interface TagPropsBase {
  icon?: IconProp;
  name?: string;
  variant?: string;
  color?: string;
}

type TagProps = React.HTMLAttributes<HTMLDivElement> & TagPropsBase;

function Tag(props: TagProps) {
  const { icon, name, variant, style: propStyle, ...rest } = props;

  const textColor = `text-${variant || 'slate'}-800`;
  const backgroundColor = `bg-${variant || 'slate'}-200`;
  const borderColor = `border-${variant || 'slate'}-300`;

  const baseStyles: React.CSSProperties = {};
  const style = { ...propStyle, ...baseStyles };
  const classes = [
    'whitespace-nowrap inline border px-2 font-semibold rounded-md text-sm z-1',
    rest.className,
  ];

  if (props.color) {
    style.backgroundColor = props.color;
    style.borderColor = props.color;
    style.color = 'white';
  } else {
    classes.push(textColor, backgroundColor, borderColor);
  }

  return (
    <div {...rest} className={classes.join(' ')} style={style}>
      {icon && <Icon fixedWidth={false} icon={icon} className="mr-1" />}
      {name && <span>{name}</span>}
    </div>
  );
}

export default Tag;
